import { Route, Routes, useNavigate } from "react-router-dom";
import Button from "../../../../components/button/Button";
import { BUTTON_TYPE } from "../../../../components/button/constants";
import PageBody from "../../../../components/pagebody/PageBody";
import { INTEGRATION_ROUTES } from "../../../constants/constants";
import WebConnector from "./webconnector/WebConnector";
import { useState } from "react";
import PlugIn from "./plugin/PlugIn";
import ExcelImport from "./excelimport/ExcelImport";
import { VEC_ICON_NAME } from "../../../../components/icons/constants";
import Icons from "../../../../components/icons/Icons";
import React from "react";
import BasicCard from "../../../../components/card/basiccard/BasicCard";
import Heading from "../../../../components/heading/Heading";
import qbdStyles from "./Qbd.styles";
import { useEffect } from "react";
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";

export default function Qbd() {
    const navigate = useNavigate();
    const [integrationPage, setIntegrationPage] = useState(false);

    const buttons = [
        { title: "WebConnector", route: INTEGRATION_ROUTES.WEB_CONNECTOR, type: BUTTON_TYPE.PRIMARY },
        { title: "PlugIn", route: INTEGRATION_ROUTES.PLUGIN, type: BUTTON_TYPE.PRIMARY },
        { title: "ExcelImport", route: INTEGRATION_ROUTES.EXCEL_IMPORT, type: BUTTON_TYPE.PRIMARY },
    ];

    const handleButtonClick = (route, source) => {
        if (source) {
            setIntegrationPage(true);
        }
        navigate(route);
    }

    useEffect(() => {
        const routeFound = buttons.some(button => window.location.hash.includes(button.route));
        if (routeFound) {
            setIntegrationPage(true);
        }
        else {
            setIntegrationPage(false);
        }
    }, [window.location.hash]);

    const breadcrumbItems = [
        { text: 'Home', link: '/' },
        { text: 'Import', link: `/${INTEGRATION_ROUTES.IMPORT}` },
    ];

    return (
        <>

            {!integrationPage && (
                <>
                    <Breadcrumbs items={breadcrumbItems} />
                    <div style={qbdStyles.headingContainer}>
                        <Heading type="h3" customStyle={qbdStyles.mainHeading}>
                            web.Tax1099 offers four ways to sync data from QuickBooks Desktop to web.Tax1099
                        </Heading>
                        <Heading type="h1" customStyle={qbdStyles.subHeading}>
                            Choose an option below to start your data sync from QuickBooks Desktop to web.Tax1099
                        </Heading>
                    </div>
                    <BasicCard>
                        <div style={qbdStyles.basicCardContainer}>

                            <div style={qbdStyles.marginRight}>
                                <Icons familyName="vec" iconName={VEC_ICON_NAME.QUICK_BOOKS_DESKTOP_LOGO} />
                            </div>

                            <div className="" style={qbdStyles.arrowContainer}>
                                <Icons familyName="vec" iconName={VEC_ICON_NAME.RIGHT_ARROW_OUTLINE} transformScale={2} style={qbdStyles.arrowIcon} />
                            </div>

                            <div style={qbdStyles.buttonPosition}>
                                <BasicCard customStyles={qbdStyles.buttonsCardContainer}>
                                    {buttons.map((button, index) => {
                                        return (
                                            <div key={index} style={qbdStyles.buttonsMargin}>
                                                <Button
                                                    type={button.type}
                                                    title={button.title}
                                                    onClickCb={() => handleButtonClick(`/${INTEGRATION_ROUTES.IMPORT}/${INTEGRATION_ROUTES.QBD}/${button.route}`, button.title)}
                                                >
                                                    {button.title}
                                                </Button>
                                            </div>
                                        );
                                    })}
                                </BasicCard>
                            </div>

                            <div style={qbdStyles.arrowContainer}>
                                <Icons familyName="vec" iconName={VEC_ICON_NAME.RIGHT_ARROW_OUTLINE} transformScale={2} style={qbdStyles.rightArrowIcon} />
                            </div>

                            <div >
                                <Icons familyName="vec" iconName={VEC_ICON_NAME.TAX1099_LOGO} transformScale={0.5} style={qbdStyles.tax1099Icon} />
                            </div>
                        </div>
                    </BasicCard>

                </>
            )}
            <PageBody>
                <Routes>
                    <Route path="/webconnector/*" element={<WebConnector />} />
                    <Route path="/plugin/*" element={<PlugIn />} />
                    <Route path="/excelimport/*" element={<ExcelImport />} />
                </Routes>
            </PageBody>
        </>
    )
}